import React, { useEffect, useState } from 'react';
import { Link } from "react-router";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useOrderStore } from '../../store/useOrderStore';
import { TableCell, TableRow } from '@mui/material';
import { formatDate, formatTime } from '../formateDate';

export default function RecentTabel() {

  const [order, setOrder] = useState([])
  const { getRecentOrder, loading } = useOrderStore()

  const getRecentOrderFunction = async () => {
    try {
      const order = await getRecentOrder(1, 4, '', '')
      console.log("product", order)
      setOrder(order)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getRecentOrderFunction()
  }, [])
  return (
    <div
      id="recent-orders-card"
      className="col-span-2 bg-white rounded-2xl shadow-sm border border-[#e5e7eb] px-7 py-6 flex flex-col"
    >
      <div className="flex items-center justify-between mb-5">
        <div className="text-lg font-semibold text-[#1e293b]">
          Recent Orders
        </div>
        <Link to="/orders" className="text-sm text-[#3b82f6] font-medium hover:underline cursor-pointer">
          View all
        </Link>
      </div>
      {/* {
        <table className="min-w-full">
          <thead>
            <tr className="text-sm text-[#94a3b8] font-medium">
              <th className="text-left py-2">Order ID</th>
              <th className="text-left py-2">Customer</th>
              <th className="text-left py-2">Products</th>
              <th className="text-left py-2">Total</th>
              <th className="text-left py-2">Status</th>
              <th className="text-left py-2"></th>
            </tr>
          </thead>
          <tbody className="text-[#1e293b]">
            <tr className="border-b border-[#f1f5f9] hover:bg-[#f9fafb]">
              <td className="py-3">#ORD-0921</td>
              <td className="py-3 flex items-center gap-2">
                <img
                  src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg"
                  className="w-7 h-7 rounded-full object-cover"
                  alt="icon"
                />
                Chloe Kim
              </td>
              <td className="py-3">3</td>
              <td className="py-3 font-semibold">$124.99</td>
              <td className="py-3">
                <span className="bg-[#d1fae5] text-[#10b981] px-3 py-1 rounded-full text-xs font-bold">
                  Delivered
                </span>
              </td>
              <td className="py-3 text-right">
                <Link to="/order/view-order" className="text-[#64748b] hover:text-[#3b82f6]">
                  <i className="fa-solid fa-ellipsis"></i>
                </Link>
              </td>
            </tr>
            <tr className="border-b border-[#f1f5f9] hover:bg-[#f9fafb]">
              <td className="py-3">#ORD-0920</td>
              <td className="py-3 flex items-center gap-2">
                <img
                  src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg"
                  className="w-7 h-7 rounded-full object-cover"
                  alt="icon"
                />
                Noah Smith
              </td>
              <td className="py-3">1</td>
              <td className="py-3 font-semibold">$49.00</td>
              <td className="py-3">
                <span className="bg-[#fef9c3] text-[#f59e42] px-3 py-1 rounded-full text-xs font-bold">
                  Pending
                </span>
              </td>
              <td className="py-3 text-right">
                <Link to="/order/view-order" className="text-[#64748b] hover:text-[#3b82f6]">
                  <i className="fa-solid fa-ellipsis"></i>
                </Link>
              </td>
            </tr>
            <tr className="border-b border-[#f1f5f9] hover:bg-[#f9fafb]">
              <td className="py-3">#ORD-0919</td>
              <td className="py-3 flex items-center gap-2">
                <img
                  src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-6.jpg"
                  className="w-7 h-7 rounded-full object-cover"
                  alt="icon"
                />
                Sophia Lee
              </td>
              <td className="py-3">2</td>
              <td className="py-3 font-semibold">$78.50</td>
              <td className="py-3">
                <span className="bg-[#fee2e2] text-[#ef4444] px-3 py-1 rounded-full text-xs font-bold">
                  Cancelled
                </span>
              </td>
              <td className="py-3 text-right">
                <Link to="/order/view-order" className="text-[#64748b] hover:text-[#3b82f6]">
                  <i className="fa-solid fa-ellipsis"></i>
                </Link>
              </td>
            </tr>
            <tr className="hover:bg-[#f9fafb]">
              <td className="py-3">#ORD-0918</td>
              <td className="py-3 flex items-center gap-2">
                <img
                  src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg"
                  className="w-7 h-7 rounded-full object-cover"
                  alt="icon"
                />
                Lucas Gray
              </td>
              <td className="py-3">5</td>
              <td className="py-3 font-semibold">$220.00</td>
              <td className="py-3">
                <span className="bg-[#dbeafe] text-[#3b82f6] px-3 py-1 rounded-full text-xs font-bold">
                  Processing
                </span>
              </td>
              <td className="py-3 text-right">
                <Link to="/order/view-order" className="text-[#64748b] hover:text-[#3b82f6]">
                  <i className="fa-solid fa-ellipsis"></i>
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
        || <Skeleton count={10} />} */}

      <div className="overflow-x-auto overflow-y-auto white common-table-wraper">
        <table className="w-full table-auto">
          <thead className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            <tr>
              <th className="p-4">Order ID</th>
              <th className="p-4">Customer</th>
              <th className="p-4">Date</th>
              <th className="p-4">Items</th>
              <th className="p-4">Total</th>
              <th className="p-4">Payment</th>
              <th className="p-4">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {loading ? (
              Array.from({ length: 5 }).map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                  {Array.from({ length: 7 }).map((_, colIndex) => (
                    <TableCell key={colIndex}>
                      <Skeleton variant="text" animation="wave" />
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              (order || []).map((ele, i) => (
                <tr key={i} className="hover:bg-gray-50">
                  <td className="p-4 font-medium text-sm text-gray-800 whitespace-nowrap">
                    {ele?.orderId}
                  </td>
                  <td className="p-4 whitespace-nowrap">
                    <div className="flex items-center">
                      {/* <img
                        src={ele?.user?.avatar}
                        alt="Customer"
                        className="w-7 h-7 rounded-full mr-1"
                      /> */}
                      <div className="whitespace-nowrap">
                        <div className="font-medium text-gray-800">{ele?.user?.fullName}</div>
                        <div className="text-xs text-gray-500">{ele?.user?.email}</div>
                      </div>
                    </div>
                  </td>
                  <td className="p-4 text-gray-600 whitespace-nowrap">
                    <div>{formatDate(ele?.createdAt)}</div>
                    <div className="text-xs text-gray-500">{formatTime(ele?.createdAt)}</div>
                  </td>
                  <td className="p-4 text-gray-600 whitespace-nowrap">{ele?.items.length}</td>
                  <td className="p-4 font-medium text-gray-800 whitespace-nowrap">
                    ${ele.totalAmountAfterCoupon}
                  </td>
                  <td className="p-4 whitespace-nowrap">
                    <span
                      className={`px-2 py-1 rounded-full text-xs
                  ${ele?.paymentStatus === "Paid" ? "bg-green-100 text-green-800" : ""}
                  ${ele?.paymentStatus === "Pending" ? "bg-yellow-100 text-yellow-800" : ""}
                  ${ele?.paymentStatus === "Failed" ? "bg-red-100 text-red-800" : ""}`}
                    >
                      {ele?.paymentStatus}
                    </span>
                  </td>
                  <td className="p-4 whitespace-nowrap">
                    <span
                      className={`px-2 py-1 rounded-full text-xs
                  ${ele?.status === "Processing" ? "bg-blue-100 text-blue-800" : ""}
                  ${ele?.status === "Shipped" ? "bg-indigo-100 text-indigo-800" : ""}
                  ${ele?.status === "Delivered" ? "bg-green-100 text-green-800" : ""}
                  ${ele?.status === "Cancelled" ? "bg-red-100 text-red-800" : ""}`}
                    >
                      {ele?.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>
  )
}
